module.exports = __webpack_public_path__ + "img/piramal.b1b79ac4.jpg";